/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchLiffActivityReplyActivityReplyIdRequest
 */
export interface PatchLiffActivityReplyActivityReplyIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchLiffActivityReplyActivityReplyIdRequest
     */
    replyText?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchLiffActivityReplyActivityReplyIdRequest
     */
    filePaths: Array<string>;
}

/**
 * Check if a given object implements the PatchLiffActivityReplyActivityReplyIdRequest interface.
 */
export function instanceOfPatchLiffActivityReplyActivityReplyIdRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filePaths" in value;

    return isInstance;
}

export function PatchLiffActivityReplyActivityReplyIdRequestFromJSON(json: any): PatchLiffActivityReplyActivityReplyIdRequest {
    return PatchLiffActivityReplyActivityReplyIdRequestFromJSONTyped(json, false);
}

export function PatchLiffActivityReplyActivityReplyIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchLiffActivityReplyActivityReplyIdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'replyText': !exists(json, 'replyText') ? undefined : json['replyText'],
        'filePaths': json['filePaths'],
    };
}

export function PatchLiffActivityReplyActivityReplyIdRequestToJSON(value?: PatchLiffActivityReplyActivityReplyIdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'replyText': value.replyText,
        'filePaths': value.filePaths,
    };
}

